


<div fxLayoutAlign="center center" *ngIf="msg">
    <div [ngClass]="{'errorRedMessageScreen':redColor,'errorGreenMessageScreen':!redColor}">
        {{msg}}
    </div>
</div>

